'use client';

import { useListAllOverheadByPeriodAndProviderQuery, useListByIdQuery } from '@/app/services/overheadApi';
import OverheadDetailsTable from '@/components/Overhead/OverheadDetailsTable';
import OverheadHeadTable from '@/components/Overhead/OverheadHeadTable';
import { usePeriod } from '@/context/PeriodContext';
import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

function OverheadDetails() {
  const { selectedPeriod } = usePeriod();
  const { id: idParam } = useParams();

  if (!idParam) {
    throw new Error('Parâmetro "id" da rota não foi definido!');
  }

  const id = Number(idParam);
  const { data: projectData } = useListByIdQuery(id, { skip: !id });

  const { data } = useListAllOverheadByPeriodAndProviderQuery(
    {
      date: selectedPeriod?.date as string,
      id: projectData?.project.id as number,
    },
    {
      skip: !selectedPeriod || !projectData?.project.id,
    },
  );

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <Box
        sx={{
          mb: 4,
          mt: 1,
        }}
      >
        <OverheadHeadTable header={projectData} />
      </Box>

      <OverheadDetailsTable rows={data || []} />
    </Box>
  );
}

export default OverheadDetails;
